import { render, staticRenderFns } from "./groupStockLReport.vue?vue&type=template&id=ff63e0a6"
import script from "./groupStockLReport.vue?vue&type=script&lang=js"
export * from "./groupStockLReport.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports